import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import {
  FieldTooltip,
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip";
import { PlusIcon } from "lucide-react";
import React, { useState } from "react";
import EmailSignaturelist from "../list/list";
import Emailcreate from "../create/create";
import { EmailSignatureData } from "../../../types";

const EmailSignatureLanding = () => {
  const [openCreateEmailSignature, setOpenCreateEmailSignature] =
    useState(false);
  const [selectedSignature, setSelectedSignature] =
    useState<any | null>(null);

  const handleAddClick = () => {
    setSelectedSignature(null); // Clear edit data for add mode
    setOpenCreateEmailSignature(true);
  };

  const handleEditSignature = (signature: any) => {
    setSelectedSignature(signature); // Set edit data for edit mode
    setOpenCreateEmailSignature(true);
  };


  return (
    <div className="space-y-6 p-1">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex justify-between items-center">
          <div>
            <PageHeader
              title="Email Signatures"
              subtitle="Manage your email signatures. You can have multiple signatures and set one as default."
            />
          </div>
        </div>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button onClick={handleAddClick}>
                <PlusIcon className="h-4 w-4 mr-2" />
                Add Signature
              </Button>
            </TooltipTrigger>
            <FieldTooltip>
              Create a new email signature to define specific audience groups
            </FieldTooltip>
          </Tooltip>
        </TooltipProvider>
      </div>

      {/* Email Signatures List */}
      <EmailSignaturelist
        openCreateEmailSignature={openCreateEmailSignature}
        setOpenCreateEmailSignature={setOpenCreateEmailSignature}
        selectedSignature={selectedSignature}
        isEdit={handleEditSignature}
        setSelectedSignature={setSelectedSignature}
      />

      {/* Single Dialog for Both Add and Edit */}
      <Emailcreate
        openCreateEmail={openCreateEmailSignature}
        setOpenCreateEmail={setOpenCreateEmailSignature}
        selectedSignature={selectedSignature}
      />
    </div>
  );
};

export default EmailSignatureLanding;